import { memo, useCallback } from 'react';

import { type SearchSavedFiltersResponse } from '@air/api/types';
import { ChevronRight } from '@air/next-icons';

import { SearchCommandItem } from '~/components/SearchCommand/SearchCommandItem';

export type SearchCommandSavedFilterListItemProps = {
  savedFilter: SearchSavedFiltersResponse;
  onSelect: (savedFilter: SearchSavedFiltersResponse) => void;
};

export const SearchCommandSavedFilterListItem = memo(
  ({ savedFilter, onSelect: _onSelect }: SearchCommandSavedFilterListItemProps) => {
    const onSelect = useCallback(() => _onSelect(savedFilter), [savedFilter, _onSelect]);

    return (
      <SearchCommandItem data-type="saved-filter" onSelect={onSelect} value={savedFilter.id}>
        <div className="flex size-10 shrink-0 items-center justify-center rounded-4 bg-grey-4 text-20 transition-colors group-data-[selected=true]/command-item:bg-grey-5">
          {savedFilter.icon}
        </div>

        <div className="grow px-1">
          <div className="truncate font-medium text-14">{savedFilter.name}</div>
        </div>
        <div className="flex size-8 shrink-0 items-center">
          <ChevronRight className="w-4 text-grey-12" />
        </div>
      </SearchCommandItem>
    );
  },
);

SearchCommandSavedFilterListItem.displayName = 'SearchCommandSavedFilterListItem';
